export default __webpack_public_path__ + "static/media/oduller.df1c49d9.jpg";